import SoundSection from './SoundSection';

export default SoundSection;
